// components/header/TopHeader.tsx
"use client";

import { Button } from "@/app/components/shadcn/button";
import TopHeaderItems from "./TopHeaderItems";
import Image from "next/image";
import Link from "next/link";
import RotatingText from "@/app/components/common/sections/RotationText";
import useHeader from "@/app/lib/features/header/header.hook";
import TopHeaderSkeleton from "@/app/components/elements/skeletons/TopHeaderSkeleton";
import { trackGeneric } from "@/app/lib/tracking/interactions";

const TopHeader = () => {
  const { header, isLoading } = useHeader();

  // Skeleton: sadece aktif olarak yükleniyorken VE henüz veri yoksa göster.
  // ISR cache'den gelen initialHeader zaten store'da — hiç skeleton görmeyiz.
  if (isLoading && !header) {
    return <TopHeaderSkeleton />;
  }

  // header null: skeleton yerine boş bar (sessiz fallback)
  if (!header) {
    return <div className="h-10 bg-black hidden md:block" />;
  }

  const apps = header?.top_bar?.apps || [];
  const announcements = header?.top_bar?.announcements || [];
  const links = header?.top_bar?.links || [];

  return (
    <div className="h-10 bg-black hidden md:block">
      <div className="container mx-auto h-full flex items-center justify-between gap-4 min-w-0">
        {/* Sol: Apps */}
        <div className="flex items-center gap-2 shrink-0">
          {apps.map((app) => (
            <Button
              key={app.key}
              size="sm"
              variant="link"
              className="rounded-md h-8 gap-2 text-gray-400 font-medium text-xs hover:underline"
              asChild
            >
              <Link
                href={app.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackGeneric(app.key, "click")}
              >
                <Image
                  src={app.icon}
                  alt=""
                  width={app.key === "whatsapp" ? 18 : 16}
                  height={app.key === "whatsapp" ? 18 : 16}
                />
                <span>{app.title}</span>
              </Link>
            </Button>
          ))}
        </div>

        {/* Orta: Announcements */}
        {announcements.length > 0 && (
          <div className="flex-1 min-w-0 flex justify-center overflow-hidden">
            <RotatingText
              items={announcements.map((text) => ({ text }))}
              mainClassName="text-gray-400 font-medium text-sm truncate"
              rotationInterval={3000}
              className="text-gray-400 font-medium"
            />
          </div>
        )}

        {/* Sağ: Links */}
        <div className="shrink-0">
          <TopHeaderItems links={links} />
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
